module.exports = __webpack_public_path__ + "static/media/design-solid.47d8dd61.svg";